import { accessingDataReporting } from "@/api";

export function renderInvalidDaysText(invalid_days, text) {
  if (!invalid_days) {
    return `长期${text}`;
  } else if (invalid_days < 0) {
    return "已过期";
  } else if (invalid_days > 30) {
    return "30天以上";
  } else {
    return `剩余 ${invalid_days} 天`;
  }
}

export function renderInvalidDaysClassName(invalid_days) {
  if (!invalid_days) {
    return "normal_days";
  } else if (invalid_days < 8) {
    return "remind_days";
  } else {
    return "normal_days";
  }
}

/**
 * 当前父级路由的children
 * @param {*} constantRoutes
 * @param {*} columnMatched
 * @returns
 */
export function parentRoute(constantRoutes, columnMatched) {
  const length = columnMatched.length - 1;

  let i = 0;

  function findRoute(i, routes = constantRoutes) {
    let childrenRoute = [];

    const columnName = columnMatched[i].name;

    const [currentRoute] = routes.filter((d) => d.name === columnName);

    if (currentRoute?.children?.length > 0) {
      childrenRoute = currentRoute.children.filter((d) => !d.hidden);
    }

    if (length > i) {
      return findRoute(++i, childrenRoute);
    } else {
      return childrenRoute;
    }
  }

  const childrenRoute = findRoute(i);

  return childrenRoute;
}

/**
 * 上报访问数据
 */
export async function handleAccessReporting(route) {
  if (!route.meta.menuKey) return;

  accessingDataReporting({
    menu: route.meta.menuKey,
  });
}
